var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 633,
    height: 633,
    viewBox: "0 0 633 633",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 633,
    height: 633,
    fill: "#002B5B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M176.2 451C166.52 451 158.233 447.708 151.34 441.123C144.447 434.538 141 426.622 141 417.375V215.625C141 206.378 144.447 198.462 151.34 191.877C158.233 185.292 166.52 182 176.2 182H457.8C467.48 182 475.767 185.292 482.66 191.877C489.553 198.462 493 206.378 493 215.625V417.375C493 426.622 489.553 434.538 482.66 441.123C475.767 447.708 467.48 451 457.8 451H176.2ZM317 333.312L176.2 249.25V417.375H457.8V249.25L317 333.312ZM317 299.688L457.8 215.625H176.2L317 299.688ZM176.2 249.25V215.625V417.375V249.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/MailIcon.299bdc925b70c89b392ff244c807b3fd.svg";
export { ForwardRef as ReactComponent };